export enum PhonesEnum {
    SUPPORT_PHONE = '912161293',
    SUPPORT_PHONE_FORMATTED = '91 216 12 93',
    SUPPORT_PHONE_CO = '912161193',
    SUPPORT_PHONE_CO_FORMATTED = '91 216 11 93',
}